"use client";

import { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Instagram, Facebook } from "lucide-react";
import { Button } from "@/components/ui/button";

const navItems = [
  { href: "#about", label: "About" },
  { href: "#services", label: "Services" },
  { href: "#contact", label: "Contact" },
];

export function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="fixed top-2 sm:top-4 left-1/2 -translate-x-1/2 z-50 w-[96%] sm:w-[95%] max-w-7xl">
      <div className="bg-white/70 dark:bg-gray-900/70 backdrop-blur-xl rounded-xl sm:rounded-2xl border border-white/20 shadow-lg px-3 sm:px-4 lg:px-8">
        <div className="flex items-center justify-between h-14 sm:h-16 md:h-20">
          <Link href="/" className="flex items-center sm:gap-3">
            <Image
              src="/images/logo.png"
              alt="Your Taormina Concierge"
              width={80}
              height={80}
              sizes="(max-width: 640px) 52px, (max-width: 768px) 64px, 80px"
              className="h-13 sm:h-16 md:h-20 w-auto"
            />
            <span className="hidden lg:block text-lg sm:text-base md:text-xl font-serif font-semibold text-foreground">
              Your Taormina Concierge
            </span>
            <span className="lg:hidden text-2xl sm:text-base md:text-xl font-serif font-semibold text-foreground">
              YTC
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6 lg:gap-8">
            {navItems.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors font-sans"
              >
                {item.label}
              </Link>
            ))}
            <div className="flex items-center gap-3">
              <a
                href="https://www.instagram.com/yourtaorminaconcierge?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                className="transition-all hover:scale-110 "
                aria-label="Instagram"
              >
                <Image
  src="/soc-icons/instagram.svg"
  alt="Instagram"
  width={30}
  height={30}
  className="transition-all hover:scale-110"
/>
              </a>
              <a
                href="https://www.facebook.com/people/Your-Taormina-Concierge/61585379998926/"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-all hover:scale-110"
                aria-label="Facebook"
              >
                <Image
  src="/soc-icons/facebook.svg"
  alt="Facebook"
  width={30}
  height={30}
  className="transition-all hover:scale-110"
/>
              </a>
            </div>
            <Button
              asChild
              className="bg-primary text-primary-foreground hover:bg-primary/90"
            >
              <Link href="#contact">Get in Touch</Link>
            </Button>
          </nav>

          {/* Mobile Social media */}
          <div className="md:hidden flex items-center gap-2 ">
            <Link
              href="https://www.instagram.com/yourtaorminaconcierge?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
              target="_blank"
              rel="noopener noreferrer"
              className=""
              aria-label="Instagram"
            >
              <Image
  src="/soc-icons/instagram.svg"
  alt="Instagram"
  width={25}
  height={25}
  className="transition-all hover:scale-110"
/>
            </Link>
            <Link
              href="https://www.facebook.com/people/Your-Taormina-Concierge/61585379998926/"
              target="_blank"
              rel="noopener noreferrer"
              className=""
              aria-label="Facebook"
            >
              <Image
  src="/soc-icons/facebook.svg"
  alt="Facebook"
  width={25}
  height={25}
  className="transition-all hover:scale-110"
/>
            </Link>
            
          
          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 text-foreground"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden mt-2 bg-white/70 dark:bg-gray-900/70 backdrop-blur-xl rounded-xl sm:rounded-2xl border border-white/20 shadow-lg overflow-hidden"
          >
            <nav className="px-4 py-4 flex flex-col gap-3">
              {navItems.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  onClick={() => setIsOpen(false)}
                  className="text-base font-medium text-muted-foreground hover:text-foreground transition-colors"
                >
                  {item.label}
                </Link>
              ))}
              
              <Button
                asChild
                className="w-full bg-primary text-primary-foreground"
              >
                <Link href="#contact" onClick={() => setIsOpen(false)}>
                  Get in Touch
                </Link>
              </Button>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
